<template>
    <div class="club-step__wine-selection-item">
        <div v-if="quantity > 0" class="multiplier">
            x{{ quantity }}
        </div>
        <div
            v-if="removeMethod"
            class="remove"
            @click="removeMethod"
            >
            <i class="fal fa-trash-alt"></i>
        </div>
        <img
            v-if="
                wine.Image &&
                wine.Image.ID &&
                wine.Image.URL
            "
            :src="wine.Image.URL"
        />
        <div v-else class="placeholder"></div>
        <p class="club-step__wine-selection-item__title">
            {{ wine.Title }}
        </p>
    </div>
</template>
<script>
    export default {
        name: "WineCard",
        props: {
            quantity: {
                type: Number,
                required: true,
                default: 0
            },
            id: {
                type: Number,
                required: true
            },
            wine: {
                type: Object,
                required: true
            },
            removeMethod: {
                type: Function
            }
        },
        created() {
            // console.log(this.actions)
        }
    }
</script>
